module.exports = __webpack_public_path__ + "img/441.fb693387.png";